import React from 'react';
import LoginForm from "../domain/user/ui/LoginForm/LoginForm";

const LoginPage = () => {


    return (
        <div className={'container'}>
            <LoginForm />
        </div>
    );
};

export default LoginPage;